
export enum LinkType {
  X = 'x',
  GITHUB = 'github',
  LINKEDIN = 'linkedin',
  FACEBOOK = 'facebook',
  WEBSITE = 'website'
}

export type AddressInfo = {
  street?: string;
  city?: string;
  state?: string;
  country_code?: string;
};